"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_RESOURCES = exports.Resource = void 0;
var Resource;
(function (Resource) {
    Resource["MEGACREDITS"] = "megacredits";
    Resource["STEEL"] = "steel";
    Resource["TITANIUM"] = "titanium";
    Resource["PLANTS"] = "plants";
    Resource["ENERGY"] = "energy";
    Resource["HEAT"] = "heat";
})(Resource = exports.Resource || (exports.Resource = {}));
exports.ALL_RESOURCES = [Resource.MEGACREDITS, Resource.STEEL, Resource.TITANIUM, Resource.PLANTS, Resource.ENERGY, Resource.HEAT];
